import { render, staticRenderFns } from "./DetailPromotion.vue?vue&type=template&id=e5da04f2&scoped=true&lang=pug&"
import script from "./DetailPromotion.vue?vue&type=script&lang=js&"
export * from "./DetailPromotion.vue?vue&type=script&lang=js&"
import style0 from "./DetailPromotion.vue?vue&type=style&index=0&id=e5da04f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5da04f2",
  null
  
)

export default component.exports